// features/findings/charts/co-occurrence-matrix.js
// Co-occurrence matrix — mechanisms (rows) × cases (columns)
// Used as Form 4 hero chart. Each cell shows whether a signal/mechanism
// is present (sage), absent (oxblood), or partial/edge-case (brass).

export function CoOccurrenceMatrix({ title, cases, signals }) {
  if (!cases || !signals || cases.length < 2 || signals.length < 2) {
    return null;
  }

  return (
    <figure className="finding-chart">
      <figcaption className="finding-chart-caption">{title}</figcaption>
      <div className="finding-cooccur-wrap">
        <table className="finding-cooccur">
          <thead>
            <tr>
              <th className="finding-cooccur-corner" />
              {cases.map((c) => (
                <th key={c.id} className={`finding-cooccur-case finding-cooccur-case-${c.outcome}`}>
                  <div className="finding-cooccur-case-name">{c.shortLabel}</div>
                  <div className="finding-cooccur-case-meta">{c.outcome}</div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {signals.map((sig) => (
              <tr key={sig.id}>
                <th className="finding-cooccur-signal">{sig.label}</th>
                {cases.map((c) => {
                  const v = sig.values[c.id];
                  const tone =
                    v?.state === 'present' ? 'present'
                    : v?.state === 'absent' ? 'absent'
                    : v?.state === 'partial' ? 'partial'
                    : 'unknown';
                  return (
                    <td key={c.id} className={`finding-cooccur-cell finding-cooccur-${tone}`}>
                      <div className="finding-cooccur-cell-mark">
                        {tone === 'present' ? '●' : tone === 'absent' ? '✕' : tone === 'partial' ? '◐' : '·'}
                      </div>
                      {v?.detail && <div className="finding-cooccur-cell-detail">{v.detail}</div>}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="finding-cooccur-legend">
        <span><span className="finding-cooccur-swatch finding-cooccur-present" /> present</span>
        <span><span className="finding-cooccur-swatch finding-cooccur-partial" /> partial / edge case</span>
        <span><span className="finding-cooccur-swatch finding-cooccur-absent" /> absent</span>
      </div>
    </figure>
  );
}

export default CoOccurrenceMatrix;
